import React from "react";



const ThirdPane = () => (

    <div className="uk-container">
    <div className="uk-width-1-1 uk-padding">
        <div className="uk-flex uk-flex-center">
        <div className="mediumContainer">
        <h3  className="header1 uk-text-center" uk-scrollspy="cls: uk-animation-slide-bottom; repeat: true">
            Why parents choose CyberTeck Academy to empower their children</h3>
        <p className="subtext uk-text-center uk-padding-small">We cater to your specific needs regarding tech education. Your time, 
            your needs, your money: we put a lot of thought into our products 
            and we’re sure you will find a fitting solution with us.
            </p>
            </div>
    </div>
    </div>

</div>
    
)



export  default  ThirdPane